<ng-template #groupEdit let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Product Group</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body text-dark">
		<div class="row">
			<div class="card">
				<div class="card-header text-center">
					<h4 class="card-title text-center"></h4>
				</div>
				<div class="card-body text-center">
					<div class="row">
						<div class="col-12">
							<div class="row">
								<div class="col-md-6">
									<mat-form-field appearance="standard">
										<mat-label>Name</mat-label>
										<input type="text" class="text-left " matInput [(value)]="editinggroup.name" (change)="updateGroup('name',$event.target.value)" />
									</mat-form-field>
								</div>
								<div class="col-md-6">
									<mat-form-field appearance="standard">
										<mat-label>Description</mat-label>
										<input type="text" class="text-left " matInput [(value)]="editinggroup.description" (change)="updateGroup('desc',$event.target.value)" />
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<mat-form-field appearance="standard">
										<mat-label>Find My</mat-label>
										<input type="text" class="text-left " matInput [(value)]="editinggroup.findmy" (change)="updateGroup('findmy',$event.target.value)" />
									</mat-form-field>
								</div>
								<div class="col-md-6">
									<mat-form-field appearance="standard">
										<mat-label>Group Type</mat-label>
										<mat-select type="text" class="text-left " matInput (selected)="updateGroup('group_type',$event.target.value)" >
										<mat-option value="1" [selected]="editinggroup.group_type == 1">
												Short List
										</mat-option>
										<mat-option value="2" [selected]="editinggroup.group_type == 2">
												Long List (trigger bottom of product list)
										</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
							</div>
							<div class="row">
								<div class="col-12">
									<h3>Group Products</h3>
									<hr>
								</div>
							</div>
							<div class="row">
								<div class="col-3">
									<mat-form-field appearance="standard">
										<mat-label>Add Product</mat-label>
										<input type="text" placeholder="Search for Product" aria-label="Product" matInput [formControl]="custsearch" [matAutocomplete]="auto">
										<mat-autocomplete #auto="matAutocomplete" (optionSelected)='addCust($event.option.value)' [displayWith]="displayFn">
											<mat-option *ngFor="let option of filteredcustomers" [value]="option">
												{{option.stockid}}: {{option.description}}
											</mat-option>
										</mat-autocomplete>
									</mat-form-field>
									<hr>
								</div>
							</div>
							<div class="row">
								<div class="col-2">

								</div>
								<div class="col-3">
									Product
								</div>
								<div class="col-3">
									Description
								</div>
							</div>
							<div class="row" *ngFor="let cust of editinggroup.members">
								<div class="col-md-2">
									<button class="btn btn-sm btn-danger" (click)="removeMember(cust)"><mat-icon>remove</mat-icon></button>
								</div>
								<div class="col-md-3">
									{{ cust.stockid }}
								</div>
								<div class="col-md-3">
									{{ cust.description }}
								</div>
							</div>
							<button mat-stroked-button color="success" aria-label="" (click)="saveGroup()" class="mt-2">
								<mat-icon>save</mat-icon> Save Group Changes
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modal-footer">
	</div>
</ng-template>
<div class="main-content">
	<div class="container-fluid">
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-header card-header-{{color}}-5">
						<h4 class="card-title "><i class="material-icons" (click)="back()">arrow_left</i> Product
							Groups</h4>
						<p class="card-category"></p>
					</div>
					<div class="card-body">
						<button mat-stroked-button color="success" aria-label="" (click)="addCustomerGroup()" class="mt-2 mb-2">
							<mat-icon>add</mat-icon> Add Product Group
						</button>

						<div class="container-fluid">
							<mat-form-field appearance="standard">
								<mat-label>Search</mat-label>
								<input type="text" class="form-control text-right" matInput [formControl]="cgroupsearch" />
							</mat-form-field>

							<div class="table ov">
								<div class="text-right">
									<span *ngIf="!searchingcgroups.length"> No Groups</span> Results ({{searchingcgroups.length}})
								</div>
								<table class="table table-sm table-striped table-hover table-bordered table-fixed ov" *ngIf="searchingcgroups.length">
									<thead class="header">
										<tr>
											<th class="header" scope="col">Group ID</th>
											<th class="header" scope="col">Description</th>
											<th class="header text-center" scope="col">
												Members</th>
										</tr>
									</thead>
									<tbody>
										<tr *ngFor="let p of searchingcgroups">
											<td>
												<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="More">
													<mat-icon>more_vert</mat-icon>
												</button>
												<mat-menu #menu="matMenu">
													<button mat-menu-item (click)="editGroup(p)"  class="btn-sm">
														<mat-icon>edit</mat-icon> Edit Group
													</button>
													<button mat-menu-item color="danger" aria-label="" (click)="removeGroup(p)" class="btn-sm">
														<mat-icon>remove</mat-icon> Remove
													</button>

												</mat-menu>
												{{ p.name }}
											</td>
											<td> {{ p.description }}</td>
											<td class="text-center">{{ p.members.length }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>